import { IEditField } from './formTools';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { EditTimeField, TimeDisplay } from './EditTime';

export const EditDueDateTimeDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => {
  return <TimeDisplay task={task} setIsEditing={setIsEditing} fieldName="dueDate" />;
};

export const EditDueDateTimeField: React.FC<IEditField> = ({ submitOnChange, cancel }) => {
  return <EditTimeField submitOnChange={submitOnChange} cancel={cancel} fieldName="dueDate" />;
};
